export function MentionChip({ handle }: { handle: string }) {
  return (
    <span data-mention="" className="cursor-pointer rounded-sm bg-mention px-0.5 font-medium text-primary">
      @{handle}
    </span>
  );
}
